<template>
  <div class="min-vh">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">FORM SETTING</h1>
      <button class="create-button" @click="handleClickCreate()">
        <font-awesome-icon icon="plus-square" />
        <span class="ml-2"> CREATE</span>
      </button>
    </div>
    <Table
      :filter="filter"
      :isBusy="isBusy"
      :items="items"
      :rows="rows"
      @pagination="pagination"
      @handleChangePerpage="handleChangePerpage"
      @handleClickUpdate="handleClickUpdate"
      @handleClickDelete="handleClickDelete"
    />
    <ModalAlertConfirm
      :msg="$t('confirmDelete')"
      :text="modalMsgDelete"
      :btnConfirm="$t('delete')"
      colorBtnConfirm="danger"
      :btnCancel="$t('cancel')"
      ref="ModalAlertConfirm"
      @confirm="onDeleteData"
    />
  </div>
</template>

<script>
import Table from "./components/Table.vue";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
export default {
  name: "CastFormSetting",
  components: { Table, ModalAlertConfirm },
  data() {
    return {
      isBusy: false,
      rows: 0,
      filter: {
        pageNo: 1,
        perPage: 10,
      },
      items: [],
      deleteId: 0,
      modalMsgDelete: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleClickCreate() {
      this.$router.push("/csat/form-setting/create").catch(() => {});
    },
    handleClickUpdate(id) {
      this.$router.push(`/csat/form-setting/${id}`).catch(() => {});
    },
    async getList() {
      this.isBusy = true;
      const result = await this.axios.post(
        `${this.$baseUrl}/Csat/Form/ListFormSetting`,
        this.filter
      );
      if (result && result?.result == 1) {
        const { count, list } = result.detail;
        this.items = list;
        this.rows = count;
      }
      this.isBusy = false;
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getList();
    },
    handleChangePerpage(perPage) {
      this.filter.pageNo = 1;
      this.filter.perPage = perPage;
      this.getList();
    },
    handleClickDelete(id, name) {
      this.deleteId = id;
      this.modalMsgDelete = `${this.$t("confirmDelete2")} ${name} ${this.$t(
        "yesOrNo"
      )}`;
      this.$refs.ModalAlertConfirm.show();
    },

    async onDeleteData() {
      this.isBusy = true;
      this.$refs.ModalAlertConfirm.hide();
      try {
        const response = await this.axios.delete(
          `${this.$baseUrl}/csat/Form/Delete/${this.deleteId}`
        );
        if (response && response.result == 1) {
          this.$store.commit("UPDATE_GLOBAL_ALERT", {
            isShow: true,
            msg: response.detail,
          });
          this.getList();
        } else {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: response.detail,
          });
        }
      } catch (err) {
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: err.message,
        });
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
